/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { CustomFieldDefinition } from '../models/customFieldDefinition';

import type { CustomFieldDefinitionCreate } from '../models/customFieldDefinitionCreate';

import type { CustomFieldDefinitionListResponse } from '../models/customFieldDefinitionListResponse';

import type { CustomFieldDefinitionReorder } from '../models/customFieldDefinitionReorder';

import type { CustomFieldDefinitionUpdate } from '../models/customFieldDefinitionUpdate';

import type { CustomFieldEntityListResponse } from '../models/customFieldEntityListResponse';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { ListDefinitionsApiV1CustomFieldsDefinitionsGetParams } from '../models/listDefinitionsApiV1CustomFieldsDefinitionsGetParams';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * List entity types that opt in to custom fields (admin picker source).
 * @summary List Entities
 */
export const listEntitiesApiV1CustomFieldsEntitiesGet = (
  signal?: AbortSignal
) => {
  return customInstance<CustomFieldEntityListResponse>({
    url: `/api/v1/custom-fields/entities`,
    method: 'GET',
    signal
  });
};

export const getListEntitiesApiV1CustomFieldsEntitiesGetQueryKey = () => {
  return [`/api/v1/custom-fields/entities`] as const;
};

export const getListEntitiesApiV1CustomFieldsEntitiesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listEntitiesApiV1CustomFieldsEntitiesGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listEntitiesApiV1CustomFieldsEntitiesGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListEntitiesApiV1CustomFieldsEntitiesGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEntitiesApiV1CustomFieldsEntitiesGet>>
  > = ({ signal }) => listEntitiesApiV1CustomFieldsEntitiesGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listEntitiesApiV1CustomFieldsEntitiesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListEntitiesApiV1CustomFieldsEntitiesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEntitiesApiV1CustomFieldsEntitiesGet>>
>;
export type ListEntitiesApiV1CustomFieldsEntitiesGetQueryError = unknown;

export function useListEntitiesApiV1CustomFieldsEntitiesGet<
  TData = Awaited<ReturnType<typeof listEntitiesApiV1CustomFieldsEntitiesGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEntitiesApiV1CustomFieldsEntitiesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEntitiesApiV1CustomFieldsEntitiesGet>>,
          TError,
          Awaited<ReturnType<typeof listEntitiesApiV1CustomFieldsEntitiesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListEntitiesApiV1CustomFieldsEntitiesGet<
  TData = Awaited<ReturnType<typeof listEntitiesApiV1CustomFieldsEntitiesGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEntitiesApiV1CustomFieldsEntitiesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEntitiesApiV1CustomFieldsEntitiesGet>>,
          TError,
          Awaited<ReturnType<typeof listEntitiesApiV1CustomFieldsEntitiesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListEntitiesApiV1CustomFieldsEntitiesGet<
  TData = Awaited<ReturnType<typeof listEntitiesApiV1CustomFieldsEntitiesGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEntitiesApiV1CustomFieldsEntitiesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Entities
 */

export function useListEntitiesApiV1CustomFieldsEntitiesGet<
  TData = Awaited<ReturnType<typeof listEntitiesApiV1CustomFieldsEntitiesGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEntitiesApiV1CustomFieldsEntitiesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListEntitiesApiV1CustomFieldsEntitiesGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List custom field definitions (incl. inactive) for the tenant.
 * @summary List Definitions
 */
export const listDefinitionsApiV1CustomFieldsDefinitionsGet = (
  params?: ListDefinitionsApiV1CustomFieldsDefinitionsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<CustomFieldDefinitionListResponse>({
    url: `/api/v1/custom-fields/definitions`,
    method: 'GET',
    params,
    signal
  });
};

export const getListDefinitionsApiV1CustomFieldsDefinitionsGetQueryKey = (
  params?: ListDefinitionsApiV1CustomFieldsDefinitionsGetParams
) => {
  return [
    `/api/v1/custom-fields/definitions`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListDefinitionsApiV1CustomFieldsDefinitionsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listDefinitionsApiV1CustomFieldsDefinitionsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListDefinitionsApiV1CustomFieldsDefinitionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDefinitionsApiV1CustomFieldsDefinitionsGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListDefinitionsApiV1CustomFieldsDefinitionsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDefinitionsApiV1CustomFieldsDefinitionsGet>>
  > = ({ signal }) =>
    listDefinitionsApiV1CustomFieldsDefinitionsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDefinitionsApiV1CustomFieldsDefinitionsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListDefinitionsApiV1CustomFieldsDefinitionsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listDefinitionsApiV1CustomFieldsDefinitionsGet>>
  >;
export type ListDefinitionsApiV1CustomFieldsDefinitionsGetQueryError =
  HTTPValidationError;

export function useListDefinitionsApiV1CustomFieldsDefinitionsGet<
  TData = Awaited<
    ReturnType<typeof listDefinitionsApiV1CustomFieldsDefinitionsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListDefinitionsApiV1CustomFieldsDefinitionsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDefinitionsApiV1CustomFieldsDefinitionsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listDefinitionsApiV1CustomFieldsDefinitionsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listDefinitionsApiV1CustomFieldsDefinitionsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDefinitionsApiV1CustomFieldsDefinitionsGet<
  TData = Awaited<
    ReturnType<typeof listDefinitionsApiV1CustomFieldsDefinitionsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListDefinitionsApiV1CustomFieldsDefinitionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDefinitionsApiV1CustomFieldsDefinitionsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listDefinitionsApiV1CustomFieldsDefinitionsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listDefinitionsApiV1CustomFieldsDefinitionsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDefinitionsApiV1CustomFieldsDefinitionsGet<
  TData = Awaited<
    ReturnType<typeof listDefinitionsApiV1CustomFieldsDefinitionsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListDefinitionsApiV1CustomFieldsDefinitionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDefinitionsApiV1CustomFieldsDefinitionsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Definitions
 */

export function useListDefinitionsApiV1CustomFieldsDefinitionsGet<
  TData = Awaited<
    ReturnType<typeof listDefinitionsApiV1CustomFieldsDefinitionsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListDefinitionsApiV1CustomFieldsDefinitionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDefinitionsApiV1CustomFieldsDefinitionsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDefinitionsApiV1CustomFieldsDefinitionsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a custom field definition.
 * @summary Create Definition
 */
export const createDefinitionApiV1CustomFieldsDefinitionsPost = (
  customFieldDefinitionCreate: CustomFieldDefinitionCreate,
  signal?: AbortSignal
) => {
  return customInstance<CustomFieldDefinition>({
    url: `/api/v1/custom-fields/definitions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: customFieldDefinitionCreate,
    signal
  });
};

export const getCreateDefinitionApiV1CustomFieldsDefinitionsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createDefinitionApiV1CustomFieldsDefinitionsPost>
      >,
      TError,
      { data: CustomFieldDefinitionCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createDefinitionApiV1CustomFieldsDefinitionsPost>
    >,
    TError,
    { data: CustomFieldDefinitionCreate },
    TContext
  > => {
    const mutationKey = ['createDefinitionApiV1CustomFieldsDefinitionsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createDefinitionApiV1CustomFieldsDefinitionsPost>
      >,
      { data: CustomFieldDefinitionCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createDefinitionApiV1CustomFieldsDefinitionsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateDefinitionApiV1CustomFieldsDefinitionsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createDefinitionApiV1CustomFieldsDefinitionsPost>>
  >;
export type CreateDefinitionApiV1CustomFieldsDefinitionsPostMutationBody =
  CustomFieldDefinitionCreate;
export type CreateDefinitionApiV1CustomFieldsDefinitionsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Definition
 */
export const useCreateDefinitionApiV1CustomFieldsDefinitionsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createDefinitionApiV1CustomFieldsDefinitionsPost>
      >,
      TError,
      { data: CustomFieldDefinitionCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createDefinitionApiV1CustomFieldsDefinitionsPost>>,
  TError,
  { data: CustomFieldDefinitionCreate },
  TContext
> => {
  const mutationOptions =
    getCreateDefinitionApiV1CustomFieldsDefinitionsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Read a single custom field definition.
 * @summary Get Definition
 */
export const getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet = (
  definitionId: string,
  signal?: AbortSignal
) => {
  return customInstance<CustomFieldDefinition>({
    url: `/api/v1/custom-fields/definitions/${definitionId}`,
    method: 'GET',
    signal
  });
};

export const getGetDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGetQueryKey =
  (definitionId?: string) => {
    return [`/api/v1/custom-fields/definitions/${definitionId}`] as const;
  };

export const getGetDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    definitionId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGetQueryKey(
        definitionId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet
        >
      >
    > = ({ signal }) =>
      getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet(
        definitionId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!definitionId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet
      >
    >
  >;
export type GetDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGetQueryError =
  HTTPValidationError;

export function useGetDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet<
  TData = Awaited<
    ReturnType<typeof getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet>
  >,
  TError = HTTPValidationError
>(
  definitionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet<
  TData = Awaited<
    ReturnType<typeof getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet>
  >,
  TError = HTTPValidationError
>(
  definitionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet<
  TData = Awaited<
    ReturnType<typeof getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet>
  >,
  TError = HTTPValidationError
>(
  definitionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Definition
 */

export function useGetDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet<
  TData = Awaited<
    ReturnType<typeof getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet>
  >,
  TError = HTTPValidationError
>(
  definitionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDefinitionApiV1CustomFieldsDefinitionsDefinitionIdGetQueryOptions(
      definitionId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a custom field definition (entity_type, key, field_type immutable).
 * @summary Update Definition
 */
export const updateDefinitionApiV1CustomFieldsDefinitionsDefinitionIdPut = (
  definitionId: string,
  customFieldDefinitionUpdate: CustomFieldDefinitionUpdate
) => {
  return customInstance<CustomFieldDefinition>({
    url: `/api/v1/custom-fields/definitions/${definitionId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: customFieldDefinitionUpdate
  });
};

export const getUpdateDefinitionApiV1CustomFieldsDefinitionsDefinitionIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDefinitionApiV1CustomFieldsDefinitionsDefinitionIdPut
        >
      >,
      TError,
      { definitionId: string; data: CustomFieldDefinitionUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateDefinitionApiV1CustomFieldsDefinitionsDefinitionIdPut
      >
    >,
    TError,
    { definitionId: string; data: CustomFieldDefinitionUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateDefinitionApiV1CustomFieldsDefinitionsDefinitionIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateDefinitionApiV1CustomFieldsDefinitionsDefinitionIdPut
        >
      >,
      { definitionId: string; data: CustomFieldDefinitionUpdate }
    > = (props) => {
      const { definitionId, data } = props ?? {};

      return updateDefinitionApiV1CustomFieldsDefinitionsDefinitionIdPut(
        definitionId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateDefinitionApiV1CustomFieldsDefinitionsDefinitionIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateDefinitionApiV1CustomFieldsDefinitionsDefinitionIdPut
      >
    >
  >;
export type UpdateDefinitionApiV1CustomFieldsDefinitionsDefinitionIdPutMutationBody =
  CustomFieldDefinitionUpdate;
export type UpdateDefinitionApiV1CustomFieldsDefinitionsDefinitionIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Definition
 */
export const useUpdateDefinitionApiV1CustomFieldsDefinitionsDefinitionIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDefinitionApiV1CustomFieldsDefinitionsDefinitionIdPut
        >
      >,
      TError,
      { definitionId: string; data: CustomFieldDefinitionUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateDefinitionApiV1CustomFieldsDefinitionsDefinitionIdPut
    >
  >,
  TError,
  { definitionId: string; data: CustomFieldDefinitionUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateDefinitionApiV1CustomFieldsDefinitionsDefinitionIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a custom field definition.
 * @summary Delete Definition
 */
export const deleteDefinitionApiV1CustomFieldsDefinitionsDefinitionIdDelete = (
  definitionId: string
) => {
  return customInstance<void>({
    url: `/api/v1/custom-fields/definitions/${definitionId}`,
    method: 'DELETE'
  });
};

export const getDeleteDefinitionApiV1CustomFieldsDefinitionsDefinitionIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteDefinitionApiV1CustomFieldsDefinitionsDefinitionIdDelete
        >
      >,
      TError,
      { definitionId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteDefinitionApiV1CustomFieldsDefinitionsDefinitionIdDelete
      >
    >,
    TError,
    { definitionId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteDefinitionApiV1CustomFieldsDefinitionsDefinitionIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteDefinitionApiV1CustomFieldsDefinitionsDefinitionIdDelete
        >
      >,
      { definitionId: string }
    > = (props) => {
      const { definitionId } = props ?? {};

      return deleteDefinitionApiV1CustomFieldsDefinitionsDefinitionIdDelete(
        definitionId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteDefinitionApiV1CustomFieldsDefinitionsDefinitionIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteDefinitionApiV1CustomFieldsDefinitionsDefinitionIdDelete
      >
    >
  >;

export type DeleteDefinitionApiV1CustomFieldsDefinitionsDefinitionIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Definition
 */
export const useDeleteDefinitionApiV1CustomFieldsDefinitionsDefinitionIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteDefinitionApiV1CustomFieldsDefinitionsDefinitionIdDelete
          >
        >,
        TError,
        { definitionId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteDefinitionApiV1CustomFieldsDefinitionsDefinitionIdDelete
      >
    >,
    TError,
    { definitionId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteDefinitionApiV1CustomFieldsDefinitionsDefinitionIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Persist a new display_order for an entity's custom field definitions.
 * @summary Reorder Definitions
 */
export const reorderDefinitionsApiV1CustomFieldsDefinitionsReorderPut = (
  customFieldDefinitionReorder: CustomFieldDefinitionReorder
) => {
  return customInstance<CustomFieldDefinitionListResponse>({
    url: `/api/v1/custom-fields/definitions/reorder`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: customFieldDefinitionReorder
  });
};

export const getReorderDefinitionsApiV1CustomFieldsDefinitionsReorderPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reorderDefinitionsApiV1CustomFieldsDefinitionsReorderPut
        >
      >,
      TError,
      { data: CustomFieldDefinitionReorder },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reorderDefinitionsApiV1CustomFieldsDefinitionsReorderPut
      >
    >,
    TError,
    { data: CustomFieldDefinitionReorder },
    TContext
  > => {
    const mutationKey = [
      'reorderDefinitionsApiV1CustomFieldsDefinitionsReorderPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reorderDefinitionsApiV1CustomFieldsDefinitionsReorderPut
        >
      >,
      { data: CustomFieldDefinitionReorder }
    > = (props) => {
      const { data } = props ?? {};

      return reorderDefinitionsApiV1CustomFieldsDefinitionsReorderPut(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReorderDefinitionsApiV1CustomFieldsDefinitionsReorderPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reorderDefinitionsApiV1CustomFieldsDefinitionsReorderPut
      >
    >
  >;
export type ReorderDefinitionsApiV1CustomFieldsDefinitionsReorderPutMutationBody =
  CustomFieldDefinitionReorder;
export type ReorderDefinitionsApiV1CustomFieldsDefinitionsReorderPutMutationError =
  HTTPValidationError;

/**
 * @summary Reorder Definitions
 */
export const useReorderDefinitionsApiV1CustomFieldsDefinitionsReorderPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reorderDefinitionsApiV1CustomFieldsDefinitionsReorderPut
        >
      >,
      TError,
      { data: CustomFieldDefinitionReorder },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof reorderDefinitionsApiV1CustomFieldsDefinitionsReorderPut>
  >,
  TError,
  { data: CustomFieldDefinitionReorder },
  TContext
> => {
  const mutationOptions =
    getReorderDefinitionsApiV1CustomFieldsDefinitionsReorderPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
